// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuln-rows {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.vuln-rows__list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.vuln-rows__item {
  padding: 0.65rem 0.85rem;
  border: 1px solid #d5e0ec;
  border-radius: 8px;
  background: #f8fafc;
}

.vuln-rows__row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 0.5rem 0.75rem;
}

.vuln-rows__item-index {
  flex: 0 0 auto;
  min-width: 1.25rem;
  padding-top: 1.55rem;
  color: #3d5a80;
  font-size: 0.9rem;
}

.vuln-rows__field {
  flex: 1 1 0;
  min-width: 0;
}

.vuln-rows__field--pop,
.vuln-rows__field--other,
.vuln-rows__field--range {
  flex: 1 1 0;
}

.vuln-rows__label {
  display: block;
  margin: 0 0 0.25rem;
  color: #3d5a80;
  font-size: 0.82rem;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vuln-rows__required {
  color: #c0392b;
  margin-left: 0.15rem;
}

.vuln-rows__other-input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  box-sizing: border-box;
  background: #fff;
}

.vuln-rows__field-error {
  margin-top: 0.2rem;
  margin-bottom: 0;
  padding-left: 1.1rem;
  line-height: 1.25;
}

.vuln-rows__char-count {
  display: block;
  margin-top: 0.15rem;
}

.vuln-rows__error {
  margin: 0.15rem 0 0;
  padding: 0 0.15rem;
  line-height: 1.25;
}

/* Match searchable-select control height within the row */
.vuln-rows__field ::ng-deep .searchable-select,
.vuln-rows__field ::ng-deep .searchable-select__input {
  width: 100%;
}

.vuln-rows__actions {
  display: flex;
  justify-content: flex-end;
  padding: 0 0.15rem;
}

.vuln-rows__add {
  padding: 0.15rem 0.35rem;
  font-size: 0.9rem;
  line-height: 1.3;
  text-decoration: none;
  color: #0d6efd;
}
.vuln-rows__add:hover:not(:disabled), .vuln-rows__add:focus {
  text-decoration: underline;
  color: #0a58ca;
}
.vuln-rows__add:disabled {
  opacity: 0.45;
  pointer-events: none;
}

.vuln-rows__remove {
  flex: 0 0 auto;
  margin-top: 1.45rem;
  padding: 0.35rem 0.5rem;
}
.vuln-rows__remove:disabled {
  opacity: 0.35;
}

@media (max-width: 767.98px) {
  .vuln-rows__row {
    flex-wrap: wrap;
    align-items: stretch;
  }
  .vuln-rows__item-index {
    padding-bottom: 0;
  }
  .vuln-rows__field {
    flex: 1 1 calc(50% - 0.75rem);
  }
  .vuln-rows__field--other {
    flex: 1 1 100%;
  }
  .vuln-rows__remove {
    align-self: flex-end;
    margin-bottom: 0;
  }
  .vuln-rows__actions {
    justify-content: flex-start;
  }
  .vuln-rows__label {
    white-space: normal;
  }
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/post-editor/vulnerability-rows-input/vulnerability-rows-input.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;;;EAGE,WAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,cAAA;EACA,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,mCAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA,0DAAA;AACA;;EAEE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AACF;AACE;EAEE,0BAAA;EACA,cAAA;AAAJ;AAGE;EACE,aAAA;EACA,oBAAA;AADJ;;AAKA;EACE,cAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AAIE;EACE,aAAA;AAFJ;;AAMA;EACE;IACE,eAAA;IACA,oBAAA;EAHF;EAMA;IACE,iBAAA;EAJF;EAOA;IACE,6BAAA;EALF;EAQA;IACE,cAAA;EANF;EASA;IACE,oBAAA;IACA,gBAAA;EAPF;EAUA;IACE,2BAAA;EARF;EAWA;IACE,mBAAA;EATF;AACF","sourcesContent":[".vuln-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.vuln-rows__list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.vuln-rows__item {\n  padding: 0.65rem 0.85rem;\n  border: 1px solid #d5e0ec;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.vuln-rows__row {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  gap: 0.5rem 0.75rem;\n}\n\n.vuln-rows__item-index {\n  flex: 0 0 auto;\n  min-width: 1.25rem;\n  padding-top: 1.55rem;\n  color: #3d5a80;\n  font-size: 0.9rem;\n}\n\n.vuln-rows__field {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.vuln-rows__field--pop,\n.vuln-rows__field--other,\n.vuln-rows__field--range {\n  flex: 1 1 0;\n}\n\n.vuln-rows__label {\n  display: block;\n  margin: 0 0 0.25rem;\n  color: #3d5a80;\n  font-size: 0.82rem;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.vuln-rows__required {\n  color: #c0392b;\n  margin-left: 0.15rem;\n}\n\n.vuln-rows__other-input {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  box-sizing: border-box;\n  background: #fff;\n}\n\n.vuln-rows__field-error {\n  margin-top: 0.2rem;\n  margin-bottom: 0;\n  padding-left: 1.1rem;\n  line-height: 1.25;\n}\n\n.vuln-rows__char-count {\n  display: block;\n  margin-top: 0.15rem;\n}\n\n.vuln-rows__error {\n  margin: 0.15rem 0 0;\n  padding: 0 0.15rem;\n  line-height: 1.25;\n}\n\n/* Match searchable-select control height within the row */\n.vuln-rows__field ::ng-deep .searchable-select,\n.vuln-rows__field ::ng-deep .searchable-select__input {\n  width: 100%;\n}\n\n.vuln-rows__actions {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 0.15rem;\n}\n\n.vuln-rows__add {\n  padding: 0.15rem 0.35rem;\n  font-size: 0.9rem;\n  line-height: 1.3;\n  text-decoration: none;\n  color: #0d6efd;\n\n  &:hover:not(:disabled),\n  &:focus {\n    text-decoration: underline;\n    color: #0a58ca;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    pointer-events: none;\n  }\n}\n\n.vuln-rows__remove {\n  flex: 0 0 auto;\n  margin-top: 1.45rem;\n  padding: 0.35rem 0.5rem;\n\n  &:disabled {\n    opacity: 0.35;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .vuln-rows__row {\n    flex-wrap: wrap;\n    align-items: stretch;\n  }\n\n  .vuln-rows__item-index {\n    padding-bottom: 0;\n  }\n\n  .vuln-rows__field {\n    flex: 1 1 calc(50% - 0.75rem);\n  }\n\n  .vuln-rows__field--other {\n    flex: 1 1 100%;\n  }\n\n  .vuln-rows__remove {\n    align-self: flex-end;\n    margin-bottom: 0;\n  }\n\n  .vuln-rows__actions {\n    justify-content: flex-start;\n  }\n\n  .vuln-rows__label {\n    white-space: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
